import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import Store from "../index";
import {
    AttendeeDataArray,
    AttendeeElasticSearchResult
} from "@/types/interfaces";
import apiSvc from "../../services/api";

@Module({
    dynamic: true,
    store: Store,
    name: "getAttendeeSearchResults",
    namespaced: true
})
export default class GetAttendeeSearchDataModule extends VuexModule {
    attendeeSearchResults: AttendeeDataArray = [];

    @Mutation
    public setAttendeeSearchResults(data: AttendeeDataArray) {
        this.attendeeSearchResults = data;
    }

    @Action({ commit: "setAttendeeSearchResults" })
    async searchAttendees(searchString: string) {
        // console.log(`Searching attendees with search term: ${searchString}`);
        return new Promise((resolve, reject) => {
            apiSvc
                .getAttendeeSearchResults(searchString)
                .then((response: any) => {
                    let returnValue = [];

                    if (response.data && response.data.hits) {
                        // console.log(`response of status ${response.status}`);
                        // console.log(`response data: ${JSON.stringify(response)}`);
                        const hits = response.data.hits;
                        returnValue = hits
                            .map((item: AttendeeElasticSearchResult) => {
                                return item._source;
                            })
                            .sort(
                                (
                                    a: { lastName: { S: "" } },
                                    b: { lastName: { S: "" } }
                                ) => {
                                    return a.lastName?.S?.localeCompare(
                                        b.lastName.S
                                    );
                                }
                            );
                    }

                    return resolve(returnValue);
                })
                .catch((error: any) => {
                    return reject(error);
                });
        });
    }
}
